;
define("item_relations_related.tpl", function(){});

